import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'semantic-ui-react'

import styles from './warning-text.css'


const propTypes = { warningText: PropTypes.string }

const defaultProps = { warningText: '' }

const WarningText = ({ warningText }) => {
  if (warningText !== '') {
    return (
      <div className={styles.warning}>
        <Icon name='warning sign' />
        {warningText}
      </div>
    )
  }
  return null
}

WarningText.propTypes = propTypes

WarningText.defaultProps = defaultProps

export default WarningText
